<header>
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark">
        <button class="navbar-toggler nav mb-1">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="container ">
            <div style="width: 100%; justify-content: center;" class="collapse navbar-collapse"
                id="navbarSupportedContent">
                <ul class="navbar-nav" style=" float: left;">

                    <li class="nav-item p-1 rounded">
                        <a class="nav-link smooth-scroll " href="#"><i class='bx bx-home'></i>
                            Home
                        </a>
                    </li>

                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#about"><i
                                class='bx bx-user'></i> 
                                About
                        </a>
                    </li>
                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#services"><i
                                class='bx bx-user'></i> 
                                Services
                        </a>
                    </li>
                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#skills"><i
                                class='bx bx-briefcase-alt'></i>
                                Skills
                        </a>
                    </li>
                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#cv"> <i
                                class='bx bx-file-blank'></i>
                                Curriculum Vitae
                            </a>
                    </li>
                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#portfolio"> <i
                                class='bx bx-book-content'></i>
                                Portfolio
                            </a>
                    </li>
                    <!-- <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#references"><i
                                class='bx bxs-badge-check'></i> 
                                References
                            </a>
                    </li> -->
                    <li class="nav-item p-1 rounded">
                        <a class="nav-link js-scroll-trigger smooth-scroll " href="#contact"> <i
                                class='bx bx-envelope'></i>
                                Contact
                            </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</header>